import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../../util/varios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
import { crearBitacora } from "../../../hooks/bitacora";

export const ImprimirPatente = (props) => {
  const op = require("../../../modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const token = localStorage.getItem("jwtToken");
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));
  const siguienteAnio = (anioactu || new Date().getFullYear()) + 1;
  const fechaActual = new Date().toISOString().split("T")[0];
  const fechaVenci = `${siguienteAnio}-12-31`;
  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [activate, setActivate] = useState(false);
  const [patente, setPatente] = useState();
  const [nueva, setNueva] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [body, setBody] = useState({
    idComercio: "",
    numLicenActual: "",
    numLicenNueva: "",
    anioNuevaLicen: "",
    fechaEmision: "",
    fechaVenci: "",
    codigo: "",
    ritm: "",
    rif: "",
    numCuenta: "",
    sector: "",
    denominacion: "",
    direccion: "",
    tipoActividad: "",
    cedula: "",
    nombre: "",
    direccionProp: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.key === "Enter" || event.which === 13) {
      buscarRegistroComercial(event.target.value);
    }
  };
  const handleFechaVencimientoBlur = (event) => {
    const { value } = event.target;
    const fechaEmision = body.fechaEmision;

    if (value && fechaEmision) {
      const fechaVencimiento = new Date(value);
      const fechaEmisionDate = new Date(fechaEmision);
      const fechaActual = new Date();
      const añoActual = fechaActual.getFullYear();
      const añoSeleccionado = fechaVencimiento.getFullYear();

      fechaVencimiento.setHours(0, 0, 0, 0);
      fechaEmisionDate.setHours(0, 0, 0, 0);

      if (
        fechaVencimiento >= fechaEmisionDate &&
        añoSeleccionado >= añoActual
      ) {
        setBody({
          ...body,
          fechaVenci: value,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Informacion",
          texto:
            "La fecha de vencimiento no puede ser menor a la fecha de emisión ni al año actual",
          icono: "informacion",
        });
        setBody({
          ...body,
          fechaVenci: fechaVenci,
        });
      }
    }
  };
  const buscarRegistroComercial = (idComercio) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/industria/consultar-comercio-persona-licencia?idComercio=${idComercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          const {
            idcomercio,
            ritm,
            cuenta,
            codigocatastral,
            rif,
            nombre,
            direccion,
            tipoactividad,
            reprelegal,
            nombres,
            direccionrepre,
          } = response.data;
          if (!tipoactividad) {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "El comercio no tiene una actividad asociada",
              icono: "error",
            });
            setBody((prev) => ({
              ...prev,
              codigo: "",
            }));
            return;
          }
          setBody((prev) => ({
            ...prev,
            codigo: prev.codigo ? prev.codigo : ritm,
            idComercio: idcomercio,
            ritm: ritm,
            rif: rif,
            numCuenta: cuenta,
            sector: codigocatastral,
            denominacion: nombre,
            direccion: direccion?.trim() || "",
            tipoActividad: tipoactividad,
            cedula: reprelegal?.trim() || "",
            nombre: nombres,
            direccionProp: direccionrepre?.trim() || "",
          }));
          setDisabled(true);
          buscarUltimaPatente(idcomercio, anioactu);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "El Comercio no existe",
            icono: "informacion",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };
  const buscarUltimaPatente = (idComercio, anio) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/industria/nrolicencia?idcomercio=${idComercio}&anio=${anio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          const { data } = response;
          if (data.ateriornrolicencia) {
            setBody((prev) => ({
              ...prev,
              anioNuevaLicen: data.anio,
              fechaEmision: new Date(data.fechaemision)
                .toISOString()
                .split("T")[0],
              fechaVenci: new Date(data.fechvence).toISOString().split("T")[0],
              numLicenActual: data.nrolicencia,
              numLicenNueva: data.nrolicencia,
            }));
            setNueva(false);
          } else {
            setNueva(true);
            setBody((prev) => ({
              ...prev,
              numLicenActual: data.actualnrolicencia,
              numLicenNueva: data.nrolicencia,
            }));
          }
          setPatente(data.nrolicencia);
        }
      })
      .catch(() => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };
  const procesarSolicitud = () => {
    try {
      setActivate(true);
      const endpoint = `${op.conexion}/api/industria/emisionpatente`;
      axios
        .post(
          endpoint,
          {
            idcomercio: body.idComercio,
            patente: patente,
            anio: anioactu,
            nueva: nueva,
            fechaEmision: body.fechaEmision,
            fechaVence: body.fechaVenci,
          },
          {
            headers: {
              "x-access-token": `${token}`,
            },
          },
        )
        .then(async (response) => {
          if (response.status === 200 && response.data) {
            console.log(response.data);
            await crearBitacora(
              "SOLICITUD DE Licencia de Industria y Comercio",
              "Licenciaxcomercio",
              patente,
            );
            imprimir();
          }
        })
        .catch((error) => {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
        })
        .finally(() => {
          setActivate(false);
        });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Procesar la Solicitud",
        icono: "error",
      });
    }
  };
  const validarCampos = () => {
    if (!body.idComercio) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Código del Comercio no debe estar vacio",
        icono: "error",
      });
    } else if (!body.denominacion) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Comercio no existe",
        icono: "error",
      });
    } else {
      procesarSolicitud();
    }
  };
  const imprimir = () => {
    const dia = fechaSistema.substring(8, 10);
    const mes = fechaSistema.substring(5, 7);
    const anio = fechaSistema.substring(0, 4);
    const nDias = new Date(dia, mes, 0).getDate();
    const nombreMes = meses[parseInt(mes) - 1];
    const reporte = "PatenteIndComAlpaezQR";
    window.open(
      op.reportes +
        "/hacienda?" +
        "reporte=" +
        reporte +
        "&ULTIMO=" +
        nDias +
        `&CONDICION=c.idcomercio=${body.idComercio}` +
        "&DIA=" +
        dia +
        "&MES=" +
        nombreMes +
        "&AÑO=" +
        anio +
        "&AÑOS=" +
        anio +
        "&idcomercio=" +
        body.idComercio +
        "&nropatente=" +
        body.numLicenNueva,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
    if (props.licencia) {
      props.onHideAcepta();
    }
    blanquear();
  };
  const cerrar = () => {
    blanquear();
    props.onHideCancela();
  };
  const blanquear = () => {
    setBody({
      idComercio: "",
      numLicenActual: "",
      numLicenNueva: "",
      anioNuevaLicen: anioactu,
      fechaEmision: fechaActual,
      fechaVenci: fechaVenci,
      codigo: "",
      ritm: "",
      rif: "",
      numCuenta: "",
      sector: "",
      denominacion: "",
      direccion: "",
      tipoActividad: "",
      cedula: "",
      nombre: "",
      direccionProp: "",
    });
    setMostrarCatalogo(false);
    setActivate(false);
    setPatente();
    setMensaje({ mostrar: false, titulo: "", msg: "" });
    setNueva(false);
    setDisabled(false);
  };
  useEffect(() => {
    if (body.fechaEmision) {
      const fechaEmision = new Date(body.fechaEmision);
      const añoEmision = fechaEmision.getFullYear();
      const mesEmision = fechaEmision.getMonth();
      const diaEmision = fechaEmision.getDate();
      const fechaVencimiento = new Date(añoEmision + 1, mesEmision, diaEmision);
      if (fechaVencimiento.getMonth() !== mesEmision) {
        fechaVencimiento.setDate(0);
      }
      const fechaVencimientoFormateada = fechaVencimiento
        .toISOString()
        .split("T")[0];
      if (body.fechaVenci !== fechaVencimientoFormateada) {
        setBody((prev) => ({
          ...prev,
          fechaVenci: fechaVencimientoFormateada,
        }));
      }
    }
  }, [body.fechaEmision]);
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        if (props && props.idcomercio && props.idcomercio > 0) {
          buscarRegistroComercial(props.idcomercio);
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          Impresión de Licencia de Industria y Comercio
        </h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
          }}
        />
        <CatalogoComercio
          titulo={""}
          mensaje={""}
          show={mostrarCatalogo}
          onHideCancelaCatCom={() => setMostrarCatalogo(false)}
          onHideAceptaCatCom={(e) => {
            setMostrarCatalogo(false);
            setBody((prev) => ({
              ...prev,
              codigo: e,
              idComercio: e,
            }));
            buscarRegistroComercial(e);
          }}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="d-flex justify-content-end">
          <div className="col-md-3 m-1 row my-auto py-2">
            <div className="input-group input-group-sm col-md-9 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nº de Licencia Actual:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numLicenActual"
                value={body.numLicenActual}
                onChange={handleChange}
                disabled
              />
            </div>
          </div>
          <div className="col-md-3 m-1 row my-auto py-2">
            <div className="input-group input-group-sm col-md-9 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nº de Nueva Licencia:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numLicenNueva"
                value={body.numLicenNueva}
                onChange={handleChange}
                disabled
              />
            </div>
          </div>
        </div>

        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Fechas
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-3 row p-auto m-auto py-2">
              <div className="input-group input-group-sm col-md-10 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Año de Nueva Licencia:
                </span>
                <select
                  className="form-control text-uppercase"
                  name="anioNuevaLicen"
                  value={body.anioNuevaLicen}
                  onChange={handleChange}
                >
                  {(() => {
                    const añoActual = new Date().getFullYear();
                    const años = [];
                    for (let i = añoActual - 5; i <= añoActual; i++) {
                      años.push(i);
                    }
                    return años.map((año) => (
                      <option key={año} value={año}>
                        {año}
                      </option>
                    ));
                  })()}
                </select>
              </div>
            </div>
            <div className="col-md-4 ml-auto p-auto m-auto row my-auto py-2">
              <div className="input-group input-group-sm col-md-10 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Fecha de Emision:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="fechaEmision"
                  value={body.fechaEmision}
                  max={fechaActual}
                  onChange={handleChange}
                  defaultValue={fechaActual}
                />
              </div>
            </div>
            <div className="col-md-4 ml-auto p-auto m-auto row my-auto py-2">
              <div className="input-group input-group-sm col-md-11 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Fecha de Vencimiento:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="fechaVenci"
                  value={body.fechaVenci}
                  onChange={handleChange}
                  defaultValue={fechaVenci}
                  onBlur={handleFechaVencimientoBlur}
                />
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Informacion
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-2 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Código:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="codigo"
                  value={body.codigo}
                  onChange={handleChange}
                  onKeyUp={handleInputNumChange}
                  onBlur={handleInputNumChange}
                  disabled={disabled}
                />
                <button
                  onClick={() => {
                    setMostrarCatalogo(true);
                  }}
                  style={{ textAlign: "center", color: "white" }}
                  className="btn btn-sm btn-info"
                  disabled={disabled}
                >
                  <i className="fas fa-search"></i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-2 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  RITM:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="ritm"
                  value={body.ritm}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>

            <div className="col-md-2 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  RIF:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="rif"
                  value={body.rif}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-3 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Nº de Cuenta:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="numCuenta"
                  value={body.numCuenta}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-4 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Sector Catastral Nº:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="sector"
                  value={body.sector}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Denominación Comercial:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="denominacion"
                  value={body.denominacion}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Tipo de Actividad:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="tipoActividad"
                  value={body.tipoActividad}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-7 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Cédula/Rif del Propietario:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="cedula"
                  value={body.cedula}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Nombre del Propietario:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="nombre"
                  value={body.nombre}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Dirección del Propietario:
                </span>
                <textarea
                  type="textarea"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccionProp"
                  value={body.direccionProp}
                  onChange={handleChange}
                  disabled
                  style={{ height: "auto" }}
                />
              </div>
            </div>
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Direccion:
                </span>
                <textarea
                  type="textarea"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  value={body.direccion}
                  onChange={handleChange}
                  disabled
                  style={{ height: "auto" }}
                />
              </div>
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-primary text-uppercase"
          onClick={validarCampos}
        >
          <i className="fas fa-print me-2"></i> Imprimir
        </button>
        <button
          onClick={blanquear}
          className="btn btn-sm btn-danger text-uppercase"
        >
          <i className="fas fa-trash"></i> Limpiar
        </button>
        <button
          className="btn btn-sm btn-danger text-uppercase"
          onClick={cerrar}
        >
          <i className="fas fa-times me-1"></i> Salir
        </button>
      </Modal.Footer>
    </Modal>
  );
};
